document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("#main [data-countdown-timer]").forEach(function (timer) {
    CountdownTimer(timer);
  });

  document.querySelectorAll(".announcement-bar [data-countdown-timer]").forEach(function (timer) {
    CountdownTimerHeader(timer);
  });

  document.querySelectorAll(".hp-gate__card [data-countdown-timer]").forEach(function (timer) {
    CountdownTimerHeader(timer);
  });

  document.querySelector(".klaviyo_popup_form_trigger").addEventListener("click", function(){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'WETLYG']);
  });

  document.querySelector(".custom_klaviyo_popup_trigger")?.addEventListener("click", function(){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'WETLYG']);
  });
});

function CountdownTimer(container) {
  var settingsEl = container.querySelector("[data-timer-settings]");
  var settings = JSON.parse(settingsEl.innerHTML);

  var year = settings.year;
  var month = settings.month;
  var day = settings.day;
  var hour = settings.hour;
  var minute = settings.minute;
  var shopTimezone = settings.shopTimezone;
  var timeZoneSelection = settings.timeZoneSelection;
  var hideTimerOnComplete = settings.hideTimerOnComplete;

  var daysEl = container.querySelector("[data-days]");
  var hoursEl = container.querySelector("[data-hours]");
  var minutesEl = container.querySelector("[data-minutes]");
  var secondsEl = container.querySelector("[data-seconds]");

  var timezoneString = timeZoneSelection === "shop" ? " GMT" + shopTimezone : "";

  var countDownDate = new Date(
    Date.parse(`${month} ${day}, ${year} ${hour}:${minute}${timezoneString}`)
  ).getTime();

  // Add active class when initialized
  container.classList.add("active");

  var timerInterval = setInterval(timerLoop, 1000);
  timerLoop();

  function timerLoop() {
    var now = Date.now();
    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // 🔥 When days reach 0 (but countdown is still running)
    if (days <= 0 && distance > 0) {
      container.classList.add("countdown-days-hidden");
    }

    if (distance < 0) {
      clearInterval(timerInterval);
      daysEl.textContent = 0;
      hoursEl.textContent = 0;
      minutesEl.textContent = 0;
      secondsEl.textContent = 0;

      container.classList.remove("active");
      container.classList.add("hidden");

      if (hideTimerOnComplete) {
        container.classList.add("hidden");
      }
    } else {
      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;
    }
  }

  return {
    destroy() {
      clearInterval(timerInterval);
    }
  };
}

function CountdownTimerHeader(container) {
  var settingsEl = container.querySelector("[data-timer-settings]");
  var settings = JSON.parse(settingsEl.innerHTML);

  var year = parseInt(settings.year, 10);
  var month = parseInt(settings.month, 10) - 1; // Safari-safe (JS months = 0-11)
  var day = parseInt(settings.day, 10);
  var hour = parseInt(settings.hour, 10);
  var minute = parseInt(settings.minute, 10);

  var shopTimezone = settings.shopTimezone; // Example: "+0500"
  var timeZoneSelection = settings.timeZoneSelection;
  var hideTimerOnComplete = settings.hideTimerOnComplete;

  var daysEl = container.querySelector("[data-days]");
  var hoursEl = container.querySelector("[data-hours]");
  var minutesEl = container.querySelector("[data-minutes]");
  var secondsEl = container.querySelector("[data-seconds]");

  // Build local date FIRST (Safari safe)
  var localDate = new Date(year, month, day, hour, minute, 0);

  // Convert shop timezone (e.g. "+0500") to offset
  function offsetFromTimezone(tz) {
    var sign = tz[0] === "-" ? -1 : 1;
    var hours = parseInt(tz.slice(1, 3), 10);
    var minutes = parseInt(tz.slice(3, 5), 10);
    return sign * ((hours * 60) + minutes) * 60 * 1000;
  }

  var countDownDate = localDate.getTime();

  // If shop timezone is selected
  if (timeZoneSelection === "shop" && shopTimezone) {
    var offset = offsetFromTimezone(shopTimezone);
    var currentOffset = new Date().getTimezoneOffset() * 60 * 1000 * -1;
    countDownDate += offset - currentOffset;
  }

  container.classList.add("active");

  var timerInterval = setInterval(timerLoop, 1000);
  timerLoop();

  function timerLoop() {
    var now = Date.now();
    var distance = countDownDate - now;

    if (distance < 0) {
      clearInterval(timerInterval);

      daysEl.textContent = "0";
      hoursEl.textContent = "0";
      minutesEl.textContent = "0";
      secondsEl.textContent = "0";

      container.classList.remove("active");
      container.classList.add("hidden");

      if (hideTimerOnComplete) {
        container.classList.add("hidden");
      }
      return;
    }

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (days <= 0 && distance > 0) {
      container.classList.add("countdown-days-hidden");
    }

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;
  }

  return {
    destroy() {
      clearInterval(timerInterval);
    }
  };
}